/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react"
import { withRouter } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { navigateToWorkshop, fetchCourseWithModules } from "../../Redux/Actions/PYP/functions"
import CommitButtonWithClickState from "../CommitButtonWithClickState/CommitButtonWithClickState"
import ProgressBar from "../ProgressBar/ProgressBar"
import { ADDITIONAL_COURSE_ID } from "../../Constants/courses"

import "../BiographyPYP/BiographyPYP.css"

const BiographyDuplicateCourse = ({ history }) => {
  const dispatch = useDispatch()
  const [courseModules, setCourseModules] = useState([])
  const [courseName, setCourseName] = useState("Course")

  const enrolledCourses = useSelector((state) => state.user?.user?.enrolled_courses || [])
  const allEnrolledModules = useSelector((state) => state.user?.user?.all_enrolled_modules || [])

  const isEnrolled = enrolledCourses.some((c) => Number(c.id) === ADDITIONAL_COURSE_ID)

  useEffect(() => {
    if (!isEnrolled) {
      setCourseModules([])
      setCourseName("Course")
      return
    }

    dispatch(fetchCourseWithModules(ADDITIONAL_COURSE_ID, { byId: true })).then((result) => {
      if (result?.course?.name) {
        setCourseName(result.course.name)
      }
      if (result?.modules?.length) {
        setCourseModules(result.modules)
      }
    })
  }, [dispatch, isEnrolled])

  const courseModuleIds = courseModules.map((m) => m.id)
  const courseUserModules = allEnrolledModules.filter((um) =>
    courseModuleIds.some((id) => Number(id) === Number(um.id))
  )

  // Resume target: first incomplete in course module order (not enrolled-list order).
  const currentModule =
    courseModules.find((module) => {
      const progress = courseUserModules.find(
        (um) => Number(um.id) === Number(module.id)
      )
      return !progress || Number(progress?.pivot?.completed) !== 1
    }) || courseModules[0]

  const completedCount = courseUserModules.filter((m) => m?.pivot?.completed === 1).length
  const totalCount = courseModules.length
  const progress = totalCount > 0 ? Math.ceil((completedCount * 100) / totalCount) : 0
  const allCompleted = totalCount > 0 && completedCount === totalCount

  const progressRow = courseUserModules.find(
    (um) => Number(um.id) === Number(currentModule?.id)
  )
  const buttonText = allCompleted
    ? "Make Edits"
    : progressRow?.pivot?.started
    ? "Resume Module"
    : "Get Started"

  const handleNavigate = (e) => {
    e.preventDefault()
    dispatch(
      navigateToWorkshop(
        history,
        null,
        courseName,
        ADDITIONAL_COURSE_ID,
        currentModule?.id
      )
    )
  }

  if (!isEnrolled || !courseModules.length) return null

  return (
    <div id="biographyDuplicateCourseContainer" className="biographyPYPContainer">
      <div className="biographyPYPText" style={{ flex: "1 1 70%" }}>
        <h2 className="biographyPYPTitle">
          {courseName} | {currentModule?.title || ""}
        </h2>
        <p className="biographyPYPDescription">
          {currentModule?.title === courseModules[0]?.title && !progressRow?.pivot?.started
            ? "You've unlocked this course. Click below to begin your journey."
            : currentModule?.description || ""}
        </p>
        <div className="bottom-section-container">
          <span className="biographyPYPResumeButton">
            <CommitButtonWithClickState
              type="red"
              clickHandler={handleNavigate}
              style={{ width: "153px", height: "40px" }}
            >
              {buttonText}
            </CommitButtonWithClickState>
          </span>
          <ProgressBar progress={progress} />
        </div>
      </div>
    </div>
  )
}

export default withRouter(BiographyDuplicateCourse)
